export default __webpack_public_path__ + "static/video-wiz-3-7478c056c8412198e4bd467c99194f26.mp4";